export default __webpack_public_path__ + "static/media/no-bonus-history.1ecf2681.svg";